import { ServiceCallQuotationDetailsModel } from "api/models/company/service-call/service-call-quotation-details-model";
import { ServiceCallQuotationItemModel } from "api/models/company/service-call/service-call-quotation-item-model";
import { DialogController } from "aurelia-dialog";
import { autoinject } from "aurelia-framework";
import { ValidationController, ValidationControllerFactory } from "aurelia-validation";
import { ValidationHelper } from "helpers/validation-helper";
import { QuotationItemEquipmentBase } from "pages/services/quotations/item-equipment-base";
import { EquipmentService } from "services/equipment-service";
import { ServiceCallQuotationService } from "services/service-call-quotation-service";
import { ServiceCallNonBillingReasonService } from "services/service-call-non-billable-reason-service";
import { I18N } from "aurelia-i18n";
import { nameof as nameof_ServiceCallQuotationItemType } from "api/enums/service-call-quotation-item-type";
import { EnumFormatValueConverter } from "converters/enums/enum-format";
import { Dialog } from "interfaces/dialog";
import { ServiceCallQuotationPriceService } from "services/service-call-quotation-price-service";
import { CloneHelper } from "helpers/cloneHelper";
import { ServiceCallContractEquipmentService } from "services/service-call-contract-equipment-service";
import { NotificationHelper } from "helpers/notification-helper";
import { Redirect, Router } from "aurelia-router";
import { RouterHelper } from "helpers/router-helper";

export interface QuotationItemEquipmentDialogParameters {
    quotationItem: ServiceCallQuotationItemModel;
    parentQuotationItem: ServiceCallQuotationItemModel | null;
    quotation: ServiceCallQuotationDetailsModel;
    isReadonly: boolean;
}

@autoinject()
export class QuotationItemEquipmentDialog extends QuotationItemEquipmentBase implements Dialog {

    public dialogHeaderTitle: string = "";

    constructor(
        validationControllerFactory: ValidationControllerFactory,
        i18N: I18N,
        serviceCallQuotationService: ServiceCallQuotationService,
        serviceCallNonBillingReasonService: ServiceCallNonBillingReasonService,
        equipmentService: EquipmentService,
        validationHelper: ValidationHelper,
        validationController: ValidationController,
        serviceCallQuotationPriceService: ServiceCallQuotationPriceService,
        serviceCallContractEquipmentService: ServiceCallContractEquipmentService,
        private readonly dialogController: DialogController,
        private readonly enumFormatValueConverter: EnumFormatValueConverter,
        private readonly routerHelper: RouterHelper, private readonly notificationHelper: NotificationHelper, private readonly router: Router
    ) {
        super(validationControllerFactory, i18N, serviceCallQuotationService, serviceCallNonBillingReasonService, equipmentService, validationHelper, validationController, serviceCallQuotationPriceService, serviceCallContractEquipmentService);
    }

    public activate(params: QuotationItemEquipmentDialogParameters): void {
        this.quotationItem = params.quotationItem;
        this.originalQuotationItem = CloneHelper.deepClone(params.quotationItem);
        this.calculationInProgress = true;
        this.profitMargin = this.quotationItem.ProfitMargin;
        this.sellingPrice = this.quotationItem.UnitPrice;
        this.calculationInProgress = false;
        this.quotation = params.quotation;
        this.dialogHeaderTitle =  this.enumFormatValueConverter.toView(this.quotationItem.Type, nameof_ServiceCallQuotationItemType);

        this.initValidation();

        if (params.isReadonly) {
            this.readonly = params.isReadonly;
        }
    }

    public async canDeactivate(): Promise<any> {
        if (this.isDirty()) {
            this.routerHelper.hideLoading(true);
            const msgWarning = this.i18n.tr("msg_UnsavedChangedWillBeLostConfirmation");
            const confirm = await this.notificationHelper.showDialogYesNo(msgWarning);
            if (!confirm) {
                return false;
            }
            this.cancel();
        }
        return true;
    }

    public async ok(): Promise<void> {
        if (this.readonly) {
            this.originalQuotationItem = null;
            this.dialogController.ok(this.quotationItem);
        }

        if (!await this.validate()) {
            return;
        }

        this.originalQuotationItem = null;
        this.dialogController.ok(this.quotationItem);
    }

    public cancel(): void {
        Object.assign(this.quotationItem, this.originalQuotationItem);
        this.originalQuotationItem = null;
        this.dialogController.cancel();
    }
}
